import { Div } from "ui"
import { Button, Text } from "ui"
import styled, { useTheme } from "styled-components"
import ModalTemplate from "../ModalTemplate"
import { ReactComponent as CheckSVG } from 'assets/icons/check-bold.svg'
import useModal from "hooks/useModal"
import { useTranslation } from "react-i18next"

const Background = styled.div`
  width: 70%;
  height: 50%;
  position: absolute;
  top: 50px;
  left: 50%;
  background-color: ${({ theme }) => theme.colors.basics.brand};
  opacity: 0.4;
  filter: blur(100px);
  transform: translateX(-50%) translate3d(0, 0, 0); // hack needed to blur works fine in iOS/safari
`

const Congrats = ({ title, description }) => {

  const { t } = useTranslation()
  const theme = useTheme()

  const { Modal } = useModal()

  return (
    <ModalTemplate customBackground={Background}>
      <Div
        height={72}
        width={72}
        borderRadius={100}
        backgroundColor={theme.colors.neutral[400]}
        display='grid'
        placeItems='center'
        margin='50px auto 0'
      >
        <CheckSVG height={32} width={32} />
      </Div>

      <Div
        display='flex'
        flexDirection='column'
        gap={16}
        marginTop={32}
        marginBottom={135}
        whiteSpace='pre-line'
      >
        <Text size='xl' color='headline' align='center'>
          {title}
        </Text>
        <Text align='center'>
          {description}
        </Text>
      </Div>

      <Div
        width='100%'
        flexGrow={1}
        display='flex'
        alignItems='end'
        marginBottom={35}
      >
        <Button isFull size='large' onClick={Modal.close}>
          {t('great')}
        </Button>
      </Div>
    </ModalTemplate>
  )
}

export default Congrats